// Currency formatting
export const formatCurrency = (cents, currency = 'ETB') => {
  const amount = (cents || 0) / 100;
  return `${amount.toLocaleString()} ${currency}`;
};

// Date formatting
export const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString();
};

export const formatDateTime = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleString();
};

export const formatRelativeTime = (date) => {
  if (!date) return '-';
  
  const now = new Date();
  const then = new Date(date);
  const diffMs = now - then;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatDate(date);
};

// Phone number formatting
export const formatPhone = (phone) => {
  if (!phone) return '-';
  // Remove country code if present
  const cleaned = phone.replace(/^\+251/, '');
  return cleaned;
};

export const formatPhoneWithCountryCode = (phone) => {
  if (!phone) return '-';
  if (phone.startsWith('+')) return phone;
  return `+251${phone}`;
};

// Number formatting
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  return num.toLocaleString();
};

export const formatPercentage = (value, total) => {
  if (!total || total === 0) return '0%';
  const percentage = (value / total) * 100;
  return `${percentage.toFixed(1)}%`;
};

// Status formatting
export const getStatusColor = (status) => {
  const statusColors = {
    // Batch statuses
    open: 'bg-blue-100 text-blue-800',
    active: 'bg-green-100 text-green-800',
    full: 'bg-yellow-100 text-yellow-800',
    completed: 'bg-gray-100 text-gray-800',
    closed: 'bg-red-100 text-red-800',
    
    // Payment statuses
    green: 'bg-green-100 text-green-800',
    yellow: 'bg-yellow-100 text-yellow-800',
    red: 'bg-red-100 text-red-800',
    defaulted: 'bg-red-100 text-red-800',
    
    // Draw statuses
    pending: 'bg-yellow-100 text-yellow-800',
    in_progress: 'bg-blue-100 text-blue-800',
    cancelled: 'bg-red-100 text-red-800',
    
    // Payout statuses
    paid: 'bg-green-100 text-green-800',
    not_paid: 'bg-gray-100 text-gray-800',
    processing: 'bg-yellow-100 text-yellow-800',
    
    // Deposit statuses
    success: 'bg-green-100 text-green-800',
    failed: 'bg-red-100 text-red-800',
    
    // Generic
    sent: 'bg-green-100 text-green-800',
  };

  return statusColors[status] || 'bg-gray-100 text-gray-800';
};

// Text formatting
export const truncate = (text, length = 50) => {
  if (!text) return '';
  if (text.length <= length) return text;
  return `${text.substring(0, length)}...`;
};

export const capitalize = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const formatRole = (role) => {
  const roles = {
    admin: 'Administrator',
    staff: 'Staff Member',
    member: 'Member',
  };
  return roles[role] || capitalize(role);
};

// File size formatting
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};
